import SearchContent from "./searchContent.jsx";
import { h, render } from "preact";

class SectionMainSearch extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.mainSearch = this.querySelector("[data-main-search]");
    this.init();
  }

  init() {
    const MainSearch = () => {
      return <SearchContent data={this.data} />;
    };

    render(<MainSearch />, this.mainSearch);
  }
}

if (!customElements.get("section-main-search")) {
  customElements.define("section-main-search", SectionMainSearch);
}
